/**
 * Came from the ENEM page (/enem/conhecer) to sign up: the profile step opens on "Vou fazer o
 * ENEM" (no institution). Kept for this tab only, like the plan intent of /planos.
 */
const KEY = 'lousa.enemIntent';

export function saveEnemIntent() {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // Private mode or storage blocked: the person just picks the option by hand.
  }
}

export function readEnemIntent(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearEnemIntent() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
